// @generated by scripts/gen-modules.mjs
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import { ModuleGuard } from '@shared/module-kit';

const MobileAppPage = lazy(() => import('./pages/MobileAppPage'));
const OfflineSyncPage = lazy(() => import('./pages/OfflineSyncPage'));
const RoutePlanningPage = lazy(() => import('./pages/RoutePlanningPage'));
const CheckInsPage = lazy(() => import('./pages/CheckInsPage'));
const VisitProofPage = lazy(() => import('./pages/VisitProofPage'));
const RepTrackingPage = lazy(() => import('./pages/RepTrackingPage'));

export const FieldRoutes: RouteObject = {
  path: 'field',
  element: <ModuleGuard moduleId="sales.field" />,
  children: [
    { path: 'mobile-app', element: <MobileAppPage />, handle: { crumb: 'Mobile App' } },
    { path: 'offline-sync', element: <OfflineSyncPage />, handle: { crumb: 'Offline Sync' } },
    { path: 'route-planning', element: <RoutePlanningPage />, handle: { crumb: 'Route Planning' } },
    { path: 'check-ins', element: <CheckInsPage />, handle: { crumb: 'Check Ins' } },
    { path: 'visit-proof', element: <VisitProofPage />, handle: { crumb: 'Visit Proof' } },
    { path: 'rep-tracking', element: <RepTrackingPage />, handle: { crumb: 'Rep Tracking' } },
  ],
};
